import React, { FC } from 'react';
import styled from 'styled-components';

import { MobileHeader } from '../Header';

const MobileLayout: FC = (props) => {
  const { children } = props;
  return (
    <Container>
      {children}
      <MobileHeader />
    </Container>
  );
};

const Container = styled.div`
  padding: 32px 16px;
  position: relative;
  margin-bottom: 64px;
`;

export default MobileLayout;
